import React from 'react'
import style from './style.module.css'

const CardFull = ({ children }) => {
  return (
    <div className={style.cardFull}>
      {children}
    </div>
  )
}

export default CardFull
